
import { 
  Camera, 
  Image as ImageIcon, 
  Layers, 
  Sliders, 
  Download, 
  Trash2, 
  Maximize2, 
  X, 
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChevronUp, 
  Save, 
  RefreshCcw, 
  Zap, 
  Box, 
  Aperture, 
  Bell, 
  User, 
  BookOpen, 
  MessageSquare, 
  Star, 
  Settings, 
  CreditCard, 
  LogOut, 
  ArrowRight, 
  Wand2, 
  Palette, 
  FileDown, 
  Keyboard, 
  Share2, 
  Eye, 
  Folder, 
  FolderPlus, 
  FolderOpen, 
  CornerDownRight, 
  Heart, 
  History, 
  Filter,
  Check,
  Sun,
  Smile,
  Sparkles,
  Crop,
  Compass,
  Briefcase,
  Monitor,
  ScanFace,
  UserCheck,
  Plus,
  Lock
} from 'lucide-react';

export const ICONS = {
  Camera,
  Image: ImageIcon,
  Layers,
  Sliders,
  Download,
  Trash: Trash2,
  Maximize: Maximize2,
  Close: X,
  Back: ChevronLeft,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  Save,
  Refresh: RefreshCcw,
  Zap,
  Box,
  Aperture,
  Bell,
  User,
  BookOpen,
  MessageSquare,
  Star,
  Settings,
  CreditCard,
  LogOut,
  ArrowRight,
  Wand: Wand2,
  Palette,
  FileDown,
  Keyboard,
  Share: Share2,
  Eye,
  Folder,
  FolderPlus,
  FolderOpen,
  CornerDownRight,
  Heart,
  History,
  Filter,
  Check,
  Sun,
  Smile,
  Sparkles,
  Crop,
  Compass,
  Briefcase,
  Monitor,
  ScanFace,
  UserCheck,
  Plus,
  Lock
};

export const MODEL_NAME = 'gemini-3-pro-image-preview';
